import { httpPost, httpDownload } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../constants/external-constants';
import {
    getGLCode,
    setGLCodeError,
    setGLCodeColSearchStr,
    sortGLCodeItems,
    setGLCodePageSize,
    setGLCodeFilter,
    applyGLCodeFilter,
    setDefaultGLCode,
} from "../../../constants/model-reducers/external/finance/gl-code.settings";
import { convertToFormatLocalDate } from '../../../utils/helpers.utils';
const defaultState = () => ({
    isGLCodeLoaded: false,
    isGLCodeError: false,
    glCodeItems: DEFAULT_TABLE_RESULT_MODEL,
    glCodeColSort: '',
    glCodeIsSortedAsc: true,
    glCodeTableFilterList: [],
    glCodeTableFilterApply: false,

});
const initialState = defaultState();
export const glCodeActions = {
    setDefaultGLCode: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultGLCode,
            glCodeItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getGLCode: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().glCode.glCodeItems;
        const { glCodeIsSortedAsc, glCodeColSort, glCodeTableFilterList, glCodeTableFilterApply } = state().glCode;

        var userId = sessionStorage.getItem('UserID');
        const headersToSend = pageUnmount ? {} : { ...Headers };

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: headersToSend,
                SortedColumnName: glCodeColSort,
                IsSortAscending: glCodeIsSortedAsc,
                TableFilterList: glCodeTableFilterList,
                ApplyFilter: glCodeTableFilterApply,
            };
            var glCodeItems = await httpPost('external/finance/getGLCodeItems', data);
            dispatch({
                type: getGLCode,
                glCodeItems: Object.keys(glCodeItems).length > 0 ? glCodeItems : DEFAULT_TABLE_RESULT_MODEL,
                isGLCodeLoaded: true,
                isGLCodeError: false
            });
        }
        catch (e) {
            dispatch({
                type: setGLCodeError,
                isGLCodeError: true,
                isGLCodeLoaded: false
            });
        }
    },
    setGLCodeColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { glCodeItems } = state().glCode;
        var glCodeItemsUpd = {
            ...glCodeItems,
            "Headers": {
                ...glCodeItems.Headers,
                [key]: {
                    ...glCodeItems.Headers[key],
                    searchString: val
                }
            }
        }
        dispatch({
            type: setGLCodeColSearchStr,
            data: glCodeItemsUpd,
            isGLCodeError: false,
            isGLCodeLoaded: true
        });
    },
    sortGLCodeItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().glCode.glCodeItems.Pagination;
        const { glCodeItems, glCodeTableFilterList, glCodeTableFilterApply } = state().glCode;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: glCodeItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...glCodeItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: glCodeTableFilterList,
            ApplyFilter: glCodeTableFilterApply,
        };
        var resGLCodeItems = await httpPost('external/finance/getGLCodeItems', data);
        if (resGLCodeItems.ok === false) {
            dispatch({
                type: setGLCodeError,
                isGLCodeError: true,
                isGLCodeLoaded: false
            });
        } else {
            dispatch({
                type: sortGLCodeItems,
                glCodeItems: Object.keys(resGLCodeItems).length > 0 ? resGLCodeItems : DEFAULT_TABLE_RESULT_MODEL,
                glCodeColSort: columnClicked,
                glCodeIsSortedAsc: isSortedAsc,
                isGLCodeLoaded: true
            });
        }
    },
    extractGLCode: () => async (dispatch, state) => {
        const { Headers } = state().glCode.glCodeItems;
        const { glCodeColSort, glCodeIsSortedAsc, glCodeTableFilterApply, glCodeTableFilterList } = state().glCode;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;
        var filename = `ATEM ${dealName} GL Code Extract – ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;
        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: glCodeColSort,
            IsSortAscending: glCodeIsSortedAsc,
            FileName: filename,
            TableFilterList: glCodeTableFilterList,
            ApplyFilter: glCodeTableFilterApply,

        };
        httpDownload('external/finance/getAllGLCodeExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
    resizeGLCodePage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setGLCodePageSize,
            pageSize: parseInt(pageSize),
        });
    },
    addGLCodeFilter: (tableFilter) => (dispatch, state) => {
        const { glCodeTableFilterList } = state().glCode;
        var filterList = [...glCodeTableFilterList, tableFilter];
        dispatch({
            type: setGLCodeFilter,
            filterList: filterList
        })
    },
    removeGLCodeFilter: (removeIndex) => (dispatch, state) => {
        const { glCodeTableFilterList } = state().glCode;
        var filterList = glCodeTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });
        dispatch({
            type: setGLCodeFilter,
            filterList: filterList
        })
    },
    applyGLCodeFilter: (isApply) => (dispatch, state) => {
        const { glCodeTableFilterList } = state().glCode;
        dispatch({
            type: applyGLCodeFilter,
            applyFilter: isApply,
            filterList: isApply ? glCodeTableFilterList : []
        });
    },
};
export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getGLCode:
            return {
                ...state,
                glCodeItems: action.glCodeItems,
                isGLCodeLoaded: action.isGLCodeLoaded,
                isGLCodeError: action.isGLCodeError
            };
        case setGLCodeError:
            return {
                ...state,
                isGLCodeError: action.isGLCodeError,
                isGLCodeLoaded: action.isGLCodeLoaded
            }
        case setGLCodeColSearchStr:
            return {
                ...state,
                glCodeItems: action.data,
                isGLCodeLoaded: action.isGLCodeLoaded,
                isGLCodeError: action.isGLCodeError
            }
        case sortGLCodeItems:
            return {
                ...state,
                glCodeItems: action.glCodeItems,
                glCodeColSort: action.glCodeColSort,
                glCodeIsSortedAsc: action.glCodeIsSortedAsc,
                isGLCodeLoaded: action.isGLCodeLoaded
            }
        case setGLCodePageSize:
            return {
                ...state,
                glCodeItems: {
                    ...state.glCodeItems,
                    Pagination: {
                        ...state.glCodeItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setGLCodeFilter:
            return {
                ...state,
                glCodeTableFilterList: action.filterList
            }
        case applyGLCodeFilter:
            return {
                ...state,
                glCodeTableFilterApply: action.applyFilter,
                glCodeTableFilterList: action.filterList
            }
        case setDefaultGLCode:
            return initialState;
        default:
            return state;
    }
};